import type { MouseEventHandler } from "react";

import { ClickableCellWrapper } from "../ClickableCellWrapper";

import { ICON_XY, StyledIcon } from "./styles";

type Props = {
    isExpanded: boolean;
    onClick: MouseEventHandler<HTMLDivElement>;
};

export const ExpandCell = ({ onClick, isExpanded }: Props) => {
    return (
        <ClickableCellWrapper
            dataAutomation="expand-cell"
            onClick={onClick}
        >
            <StyledIcon
                size={`${ICON_XY}px`}
                iconName={isExpanded ? "minus-square" : "plus-square"}
            />
        </ClickableCellWrapper>
    );
};
